const appConfig = {
  "name": "pfmla-v2-main",
  "version": "0.1.0",
  "stage": "dev",
  "deployThisBuild": false,
  "okta": {
    "issuer": "https://okta.mit.edu/oauth2/aus6shg1319alZcDf697",
    "clientId": "3f5qjrvmecuitet8um37oj8qt",
    "redirectUris": [
      "https://hrfeeds-dev.mit.edu",
      "https://hrfeeds.atlas-apps-dev.mit.edu"
    ],
    "postLogoutRedirectUris": [
      "https://hrfeeds-dev.mit.edu/logout",
      "https://hrfeeds.atlas-apps-dev.mit.edu/logout"
    ],
    "scopes": [
      "address",
      "digital-id/user",
      "email",
      "offline_access",
      "openid",
      "pfmla/export",
      "phone",
      "profile",
      "user/admin.pfml",
      "user/all"
    ]
  },
  "amplify": {
    "userPoolId": "us-east-1_14cFcpuS8",
    "userPoolWebClientId": "3f5qjrvmecuitet8um37oj8qt",
    "oauth": {
      "domain": "atlas-auth-dev.mit.edu",
      "scope": [
        "digital-id/user",
        "openid",
        "pfmla/export",
        "profile",
        "user/admin.pfml",
        "user/all"
      ],
      "redirectUris": [
        "https://hrfeeds-dev.mit.edu",
        "https://hrfeeds.atlas-apps-dev.mit.edu"
      ],
      "postLogoutRedirectUris": [
        "https://hrfeeds-dev.mit.edu/logout",
        "https://hrfeeds.atlas-apps-dev.mit.edu/logout"
      ],
      "responseType": "token",
      "options": {
        "AdvancedSecurityDataCollectionFlag": false
      }
    }
  }
};
export default appConfig;